const openAndScrollToDetails = () => {
  document.addEventListener('DOMContentLoaded', () => {
    const learnMoreLinks = document.querySelectorAll('a.lana-ai-learn-more-link');

    if (!learnMoreLinks.length) {
      return;
    }

    learnMoreLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();

        const targetId = link.getAttribute('href').substring(1);
        const targetDetailsElement = document.getElementById(targetId);

        if (targetDetailsElement && targetDetailsElement.tagName.toLowerCase() === 'details') {
          targetDetailsElement.setAttribute('open', '');
          targetDetailsElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    });
  });
};

openAndScrollToDetails();
